import { useTranslation } from "react-i18next";
import { Icon } from "semantic-ui-react";

import { CAR_TYPE } from "models";

import type { DropdownItemProps } from "components";

type ContentProps = {
  text: string;
  icon?: string;
};

const VehicleTypeContent = ({ icon, text }: ContentProps) => (
  <div className="vehicle-type-content">
    {icon && <Icon className={icon} />}
    <span> {text} </span>
  </div>
);

export const SELECT_ALL_CAR_TYPES = -1;

export const useVehicleTypeDropdownOptions = (): DropdownItemProps[] => {
  const { t } = useTranslation();

  return [
    { key: SELECT_ALL_CAR_TYPES, value: SELECT_ALL_CAR_TYPES, content: <VehicleTypeContent text={t("v8_all", "All")} /> },
    { key: CAR_TYPE.Car, value: CAR_TYPE.Car, content: <VehicleTypeContent icon="car" text={t("v8_car", "Car")} /> },
    { key: CAR_TYPE.Truck, value: CAR_TYPE.Truck, content: <VehicleTypeContent icon="truck" text={t("v8_truck", "Truck")} /> },
    { key: CAR_TYPE.Van, value: CAR_TYPE.Van, content: <VehicleTypeContent icon="van shuttle" text={t("v8_van", "Van")} /> },
    { key: CAR_TYPE.Bus, value: CAR_TYPE.Bus, content: <VehicleTypeContent icon="bus" text={t("v8_bus", "Bus")} /> },
    { key: CAR_TYPE.Motorcycle, value: CAR_TYPE.Motorcycle, content: <VehicleTypeContent icon="motorcycle" text={t("v8_motorcycle", "Motorcycle")} /> },
    { key: CAR_TYPE.LightTruck, value: CAR_TYPE.LightTruck, content: <VehicleTypeContent icon="truck pickup" text={t("v8_light_truck", "Light Truck")} /> },
    { key: CAR_TYPE.Unknown, value: CAR_TYPE.Unknown, content: <VehicleTypeContent icon="circle question" text={t("v8_unknown", "Unknown")} /> }
  ];
};
